import {
  AgentInfoSaleRelatedComponent,
  ContactInfoSaleRelatedComponent,
  DetailsSaleRelatedComponent,
  InvoiceSaleRelatedComponent,
  SummarySaleRelatedComponent,
} from '../Sections';

export const UnitsSaleRelatedSteps = [
  { label: 'agent-info', component: AgentInfoSaleRelatedComponent },
  { label: 'contact-info', component: ContactInfoSaleRelatedComponent },
  { label: 'details', component: DetailsSaleRelatedComponent },
  { label: 'invoice-description', component: InvoiceSaleRelatedComponent },
  { label: 'summary', component: SummarySaleRelatedComponent },
];
